import { c as _c } from "react/compiler-runtime";
import { useIntl } from "react-intl";
import type { CityProps } from "forms/fields/ContactData/types";
import FormItem from "forms/fields/FormItem";
import { predefinedFields } from "types/predefinedFields";
import { FormField } from "uiShadcn/form";
import { Input } from "uiShadcn/input";
export default function City(t0) {
  const $ = _c(6);
  const {
    control,
    data
  } = t0;
  const {
    formatMessage
  } = useIntl();
  let t1;
  if ($[0] !== data?.type || $[1] !== formatMessage) {
    t1 = t2 => {
      const {
        field
      } = t2;
      return <FormItem label={formatMessage({
        id: "city"
      })} required={data?.type === "string"}><Input dataTestId={`Input-${field.name}`} placeholder={formatMessage({
          id: "enter"
        })} required={data?.type === "string"} {...field} /></FormItem>;
    };
    $[0] = data?.type;
    $[1] = formatMessage;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== control || $[4] !== t1) {
    t2 = <FormField control={control} name={predefinedFields.city} render={t1} />;
    $[3] = control;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}